import { Component, Input } from '@angular/core'

@Component({
    selector: 'mg-checkout-action-banner',
    templateUrl: './checkout-action-banner.component.html',
    styleUrls: ['./checkout-action-banner.component.scss'],
})
export class CheckoutActionBannerComponent {
    @Input() color: 'purple' | 'black' | 'red' | 'blue' | 'blueInfo' | 'green' = 'purple'
    @Input() content: string
}
